import React, { memo } from 'react';

const BigChat = memo(({ size = 70 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          d="M19.5423 59.7625C24.034 62.5625 29.3131 64.1667 35.0006 64.1667C51.1006 64.1667 64.1673 51.1 64.1673 35C64.1673 18.9 51.1006 5.83337 35.0006 5.83337C18.9007 5.83337 5.83398 18.9 5.83398 35C5.83398 40.6875 7.43815 45.9667 10.2673 50.4584"
          stroke="#D2552B"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5423 59.7625L5.83398 64.1667L10.2673 50.4584"
          stroke="#D2552B"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});

export default BigChat;
